<ng-container>
  <div class="course-pictures">
    <div class="section-title">
      <h4 class="h4" *ngIf="!mediaTitle">{{translationScope+'.titles.course_images' | transloco}}</h4>
      <h4 class="h4" *ngIf="mediaTitle"> {{ mediaTitle }}</h4>
    </div>

    <div class="course-images">
      <div class="container  image-carosal-container d-none d-sm-block">
        <div class="row activity-image-owl-carousel">
          <ng-container *ngFor="let media of medias; let i = index">
            <div class="col-12 col-sm-6 activity-images-item">
              <div class="activity-images-thum">
                <img
                  class="fs-gal img-fluid"
                  (click)="openImagePreviewer(media)"
                  src="{{
                    media?.url
                  }}?h=512&w=512&fit=crop,faces&auto=compress,enhance"
                  alt="{{ media.name }}"
                />
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="container image-carosal-container d-block d-sm-none">
        <div class="row activity-image-owl-carousel with-slider">
          <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <ng-template ngFor let-media [ngForOf]="getExperienceNonDefaultMedia(medias)">
              <div ngxSlickItem class="owl-carousel-item slide col-12">
                <div class="activity-images-item">
                  <div class="activity-images-thum">
                    <img class="fs-gal img-fluid" (click)=" openImagePreviewer(getExperienceNonDefaultMedia(medias))"
                      src="{{ media?.url }}?h=512&w=512&fit=crop,faces&auto=compress,enhance" alt="{{ media.name }}" />
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-slick-carousel>
        </div>
      </div>
    </div>
  </div>
</ng-container>
